import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';

@Injectable({
    providedIn: 'root'
})
export class MyAddressBookService {

    constructor(private http: HttpClient,
        private occService: OccEndpointsService,) { }


    getApi() {
        return this.http.get(this.occService.buildUrl(`myaccount/addressbook/address-book`));
    }
    removeAddress(code) {
        return this.http.post(this.occService.buildUrl(`myaccount/addressbook/remove-address?addressCode=${code}`), null);
    }
    //Editing the existing addresses
    getEditableAddress(addCode) {
        return this.http.get(this.occService.buildUrl(`myaccount/addressbook/edit-address?addressCode=${addCode}`));
    }
    updateEditedAddress(payLoad) {
        return this.http.post(this.occService.buildUrl(`myaccount/addressbook/edit-address`), payLoad);
    }
    //Adding new Address
    getAddAddressApi() {
        return this.http.get(this.occService.buildUrl(`myaccount/addressbook/add-address`));
    }
    AddAddress(payLoad) {
        return this.http.post(this.occService.buildUrl(`myaccount/addressbook/add-address`), payLoad);
    }
    //search Api
    getAddressAfterSearch(searchText, currentPage) {
        return this.http.get(this.occService.buildUrl(`myaccount/addressbook/address-book?searchKey=${searchText}&page=${currentPage}`));
    }

    //state
    getRegions(isoCode) {
        return this.http.get(this.occService.buildUrl(`kbregistration/regions/?countryIso=${isoCode}`));
    }
}
